import { useParams } from "react-router-dom";

import { useCounselorsQuery } from "@/common/hooks/useCounselorsQuery";
import { CounselorByIdParams } from "@/router/SystemSettingsRoutes";

export function useCounselor() {
  const { id } = useParams<CounselorByIdParams>();

  const { data, isLoading } = useCounselorsQuery();

  const counselor = data?.find((entry) => entry.counselorId === id);

  return { counselor, isLoading };
}
